import { fetchConfig } from '@/api/event';
import { ConfigResponse } from '@/api/types';
import {
  useSuspenseQuery,
  UseSuspenseQueryResult,
} from '@tanstack/react-query';

const useConfigQuery = (): UseSuspenseQueryResult<ConfigResponse> => {
  return useSuspenseQuery({
    queryKey: ['config'],
    queryFn: fetchConfig,
  });
};

const getQueryKey = () => ['config'];
useConfigQuery.getQueryKey = getQueryKey;

export default useConfigQuery;
